var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.04 13.843C17.62 14.253 17.38 14.843 17.44 15.473C17.53 16.553 18.52 17.343 19.6 17.343H21.5V18.533C21.5 20.603 19.81 22.293 17.74 22.293H6.26C4.19 22.293 2.5 20.603 2.5 18.533V11.803C2.5 9.73298 4.19 8.04297 6.26 8.04297H17.74C19.81 8.04297 21.5 9.73298 21.5 11.803V13.243H19.48C18.92 13.243 18.41 13.463 18.04 13.843Z",
    stroke: "#EF233C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.7023V8.13234C2.5 6.94234 3.23 5.8823 4.34 5.4623L12.28 2.4623C13.52 1.9923 14.85 2.91233 14.85 4.24233V8.04231",
    stroke: "#EF233C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5588 14.2621V16.3222C22.5588 16.8722 22.1188 17.3222 21.5588 17.3422H19.5988C18.5188 17.3422 17.5288 16.5522 17.4388 15.4722C17.3788 14.8422 17.6188 14.2522 18.0388 13.8422C18.4088 13.4622 18.9188 13.2422 19.4788 13.2422H21.5588C22.1188 13.2622 22.5588 13.7121 22.5588 14.2621Z",
    stroke: "#EF233C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.293H14",
    stroke: "#EF233C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget.c2f54c4fc6db7310784b7dd17f83f55f.svg";
export { ForwardRef as ReactComponent };